import { Toast } from "antd-mobile";
import * as Api from "../utils/api";
import Http from "./http";
const HttpInstance = new Http();

class Utils {
  // 微信分享基本配置
  wxShareConfig(
    params,
    isApp,
    courseId = undefined,
    title = undefined,
    desc = undefined,
    iconUrl = "/File/h5/fsslh5/graSeason_share.png"
  ) {
    let obj = params;
    // console.log('微信分享配置参数obj', obj);
    let url = encodeURIComponent(window.location.href.split("#")[0]);
    // console.log('href', window.location.href)
    // console.log('url', url)
    let jsConfigGZH = HttpInstance.get("api/JsSdkConf/GetJsConfGZH?url=" + url);
    jsConfigGZH.then((res) => {
      // console.log(res);
      let data = res.data.data;
      // 判断是否是app
      // let isApp = HttpInstance.getSearchByName(this.props.location.search, "isApp");
      // console.log('判断是否是App', isApp)
      if (!isApp) {
        // 通过config接口注入权限验证配置
        window.$wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appID, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名
          jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline"], // 必填，需要使用的JS接口列表
        });
        window.$wx.ready(function () {
          // console.log(courseId)
          // console.log(Boolean(courseId))

          // 获取分享给朋友按钮点击状态及自定义分享内容接口'https://college-paytest.fs-salon.cn/fsslh5/#/home'
          if (!courseId) {
            // console.log('分享链接地址', Api.AUTH_GLOBAL_URL);
            window.$wx.onMenuShareAppMessage({
              title: "放射沙龙影像学苑", // 分享标题
              desc: "“0“元看课，分享实战病例，提升诊断思维", // 分享描述
              link: Api.AUTH_WAYPAY_URL + "fssl-gzh/#/index", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: Api.imageGlobalUrl + iconUrl, // 分享图标
              // type: '', // 分享类型,music、video或link，不填默认为link
              // dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
              success: function () {
                // 用户点击了分享后执行的回调函数
                // Toast.info('分享成功！')
                // shareRecord();
              },
            });
            // 获取分享到朋友圈按钮点击状态及自定义分享内容接口
            window.$wx.onMenuShareTimeline({
              title: "放射沙龙", // 分享标题
              desc: "你的影像深造医学苑", // 分享描述
              link: Api.AUTH_GLOBAL_URL + "?data=data", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: Api.imageGlobalUrl + iconUrl, // 分享图标
              // type: '', // 分享类型,music、video或link，不填默认为link
              // dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
              success: function () {
                // 用户点击了分享后执行的回调函数
                // Toast.info('分享成功！')
                // shareRecord();
              },
            });
          } else {
            // console.log('分享链接地址', Api.AUTH_GLOBAL_COURSE_URL + '?courseID=' + courseId);
            window.$wx.onMenuShareAppMessage({
              title: title, // 分享标题
              desc: desc, // 分享描述
              link: Api.AUTH_GLOBAL_COURSE_URL + "?courseID=" + courseId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: Api.imageGlobalUrl + iconUrl, // 分享图标
              // type: '', // 分享类型,music、video或link，不填默认为link
              // dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
              success: function () {
                // 用户点击了分享后执行的回调函数
                // Toast.info('分享成功！')
                shareRecord();
              },
            });
            // 获取分享到朋友圈按钮点击状态及自定义分享内容接口
            window.$wx.onMenuShareTimeline({
              title: title, // 分享标题
              desc: desc, // 分享描述
              link: Api.AUTH_GLOBAL_COURSE_URL + "?courseID=" + courseId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: Api.imageGlobalUrl + iconUrl, // 分享图标
              // type: '', // 分享类型,music、video或link，不填默认为link
              // dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
              success: function () {
                // 用户点击了分享后执行的回调函数
                // Toast.info('分享成功！')
                shareRecord();
              },
            });
          }
          function shareRecord() {
            console.log("统计分享次数");
            // let params = {};
            // params.shareType = 2;
            // params.shareId = courseId;
            let response = HttpInstance.get(
              Api.ADD_SHARERECORD_API + "?shareType=2&shareId=" + courseId
            );
            response.then((res) => {});
          }
          // 通过error接口处理失败验证
          // config信息验证失败会执行error函数
          window.$wx.error(function (err) {
            console.log("错误信息", JSON.stringify(err));
          });
        });
      }
    });
  }

  // 判断是不是iOS环境
  judgeIsIOS() {
    let isIphone = navigator.userAgent.includes("iphone");
    let isIpad = navigator.userAgent.includes("iPad");
    return isIphone || isIpad;
  }

  converToNum = (number) => {
    return number > 9999 ? Math.ceil(number / 1000) / 10 + "万" : number;
  };
}

export default Utils;
